module.exports = __webpack_public_path__ + "img/ikc.3235abc8.png";